<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title class="btn btn-rose">Add New Product</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="addProductForm" (ngSubmit)="addProductForm.valid && saveProduct()" novalidate>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" color="accent">
                      <mat-label>Product Name</mat-label>
                      <input matInput type="text" placeholder="Enter Product Name" name="productName" id="productName"
                             formControlName="productName" autocomplete="off" appInputValidator
                             [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true">
                      <mat-error *ngIf="addProductForm.get('productName').hasError('required')">
                        Product Name is required.
                      </mat-error>
                      <mat-error *ngIf="addProductForm.get('productName').hasError('maxlength')">
                        Product Name cannot be more than 50 characters.
                      </mat-error>
                      <mat-error *ngIf="addProductForm.get('productName').hasError('noAlphabet')">
                        Must contain at least one alphabet.
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" color="accent">
                      <mat-label>Description</mat-label>
                      <input matInput type="text" placeholder="Enter Description" name="description" id="description"
                             formControlName="description" autocomplete="off" appInputValidator
                              [sanitizeScriptTags]="true" [hasAtLeastOneAlphabet]="true" >
                      <mat-error *ngIf="addProductForm.get('description').hasError('required')">
                        Description is required.
                      </mat-error>
                      <mat-error *ngIf="addProductForm.get('description').hasError('maxlength')">
                        Description cannot be more than 100 characters.
                      </mat-error>
                       <mat-error *ngIf="addProductForm.get('description').hasError('noAlphabet')">
                         Must contain at least one alphabet.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </form>
        </mat-card-content>
        <mat-card-footer>
            <div class="row action-btn justify-content-center">
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="close()">Close</button>
                </div>
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="saveProduct()" [disabled]="!addProductForm.valid">Save</button>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
</div>